import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: () => import('../views/Home.vue')
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import('../views/Login.vue')
	},
	{
		path: '/shows',
		name: 'Shows',
		component: () => import('../views/Shows.vue')
  	},
  	{
		path: '/content',
		name: 'Content',
		component: () => import('../views/Content.vue')
	},
	{
		path: '/create',
		name: 'Create',
		component: () => import('../views/Create.vue')
	},
	{
		path: '/preview/:id',
		name: 'Preview',
		component: () => import('../views/Preview.vue')
	},
	{
		path: '/showedit/:id',
		name: 'ShowEdit',
		component: () => import('../views/ShowEdit.vue')
	}
]

const router = new VueRouter({
	routes
})

export default router
